import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useMediaQuery, createBreakpoints } from 'WeployDesignLanguage/mediaQueries';

import Grid from 'LegacyWeployDesignLanguage/Grid';
import Checkbox from 'LegacyWeployDesignLanguage/inputs/Checkbox';
import Button from 'WeployDesignLanguage/buttons/Button';


const StyledConfirmationWrapper = styled.div`
  padding: ${props => props.theme.spacing[3]} 0;
`;

const StyledSpan = styled.span`
  ${props => props.theme.typography.body1};
  color: ${props => props.theme.colors.text.primary};
`;

const StyledButtonWrapper = styled.div`
  padding: ${props => props.theme.spacing[1]} 0;
  text-align: right;
`;

const StyledCheckbox = styled(Checkbox)`
  &.MuiCheckbox-root {
    align-self: flex-start;
    margin-top: -${props => props.theme.spacing[1]};
  }
`;

const PaymentConfirmation = ({ onConfirmButtonClick, paymentTermId }) => {
  const [declared, setDeclared] = useState(false);

  const { DOWN_SM, UP_XL } = createBreakpoints();
  const mobileUser = useMediaQuery(DOWN_SM);
  const xlUser = useMediaQuery(UP_XL);

  return (
    <>
      <StyledConfirmationWrapper>
        <Grid container justify="space-between" direction={(mobileUser || xlUser) ? 'column' : 'row'} alignItems={(mobileUser || xlUser) && 'flex-end'}>
          <Grid item md={8} lg={12}>
            <StyledCheckbox
              onChange={() => setDeclared(!declared)}
              label={<StyledSpan>By checking this box I declare the hours worked are accurate and authorise payment for the total amount</StyledSpan>}
            />
          </Grid>
          <Grid item md={4} lg={12}>
            <StyledButtonWrapper>
              <Button onClick={onConfirmButtonClick} disabled={!declared || !paymentTermId}>
                Confirm Timesheets
              </Button>
            </StyledButtonWrapper>
          </Grid>
        </Grid>
      </StyledConfirmationWrapper>

    </>
  );
};

PaymentConfirmation.propTypes = {
  onConfirmButtonClick: PropTypes.func.isRequired,
  paymentTermId: PropTypes.string,
};

PaymentConfirmation.defaultProps = {
  paymentTermId: '',
};

export default PaymentConfirmation;

